package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBriefcase
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.models.Job
import io.horion.cv.models.JobType
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.TypeJobColors
import io.horion.cv.utils.jobsList
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun ColonneInfo(
    job: Job,
    breakpoint: Breakpoint,
    vertical:Boolean = true,
    isDark: Boolean
) {

    if (vertical) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = 10.px),
            horizontalArrangement = Arrangement.spacedBy(if (breakpoint >= Breakpoint.MD) 20.px else 5.px)
        ) {

            //  Localisation
            InfoItem(
                icon = {
                    FaLocationDot(
                        modifier = Modifier.margin(right = 8.px),
                        size = IconSize.SM
                    )
                },
                text = job.city,
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )

            //  Type de job
            InfoItem(
                icon = {
                    FaBriefcase(
                        modifier = Modifier.margin(right = 8.px),
                        size = IconSize.SM
                    )
                },
                text = job.type.toString(),
                breakpoint = breakpoint,
                bordered = true,
                jobType = job.type,
                isDark = isDark
            )

            //  Expérience
            InfoItem(
                icon = null,
                text = job.experience.toString(),
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )

            //  Statut
            InfoItem(
                icon = null,
                text = job.status.toString(),
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )
        }
    }
    else{
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .margin(left = 10.px),
            verticalArrangement = Arrangement.spacedBy(if (breakpoint >= Breakpoint.MD) 20.px else 5.px)
        ) {

            // Localisation
            InfoItem(
                icon = {
                    FaLocationDot(
                        modifier = Modifier.margin(right = 8.px),
                        size = IconSize.SM
                    )
                },
                text = job.city,
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )

            //  Type de job
            InfoItem(
                icon = {
                    FaBriefcase(
                        modifier = Modifier.margin(right = 8.px),
                        size = IconSize.SM
                    )
                },
                text = job.type.toString(),
                breakpoint = breakpoint,
                bordered = true,
                jobType = job.type,
                isDark = isDark
            )

            //  Expérience
            InfoItem(
                icon = null,
                text = job.experience.toString(),
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )

            //  Statut
            InfoItem(
                icon = null,
                text = job.status.toString(),
                breakpoint = breakpoint,
                jobType = job.type,
                isDark = isDark
            )
        }
    }
}

@Composable
fun InfoItem(
    icon: (@Composable () -> Unit)? = null,
    text: String,
    breakpoint: Breakpoint,
    bordered: Boolean = false,
    jobType: JobType,
    isDark: Boolean
) {
    val isMobile = breakpoint < Breakpoint.SM
    val borderColor = TypeJobColors.getColor(jobType)
    val iconFilter = if (isDark) "invert(1)" else "none"

    Row(
        modifier = Modifier
            .borderRadius(8.px)
            .then(
                if (bordered)
                    Modifier.border(1.px, LineStyle.Solid, borderColor)
                else Modifier
            )
            .padding(leftRight = if (breakpoint >= Breakpoint.MD) 10.px else 5.px, topBottom = 6.px),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(if (isMobile) 4.px else 8.px)
    ) {

        // ICON
        icon?.invoke()

        // TEXT
        SpanText(
            text = text,
            modifier = Modifier
                .fontSize(if (breakpoint >= Breakpoint.MD) 14.px else 12.px)
                .color(when {
                    text == "ACTIVE" -> Colors.LighterBlue
                    text == "FILLED" -> Colors.orange
                    isDark -> Colors.White
                    else -> Colors.HalfBlack
                })
                .fontFamily(INTER)
                .fontWeight(FontWeight.Medium)
                .whiteSpace(WhiteSpace.NoWrap)
        )
    }
}